<template>
  <div class="col col-lg-3 mt-4">
    <div class="input-group">
      <label>
        Prefixo
        <input
          @input="checkSpecialCharacters"
          maxlength="150"
          class="form-control mt-2"
          :class="{
            'is-invalid': $v.model.content.$error,
            'recent-updated': recentUpdatedField,
          }"
          :disabled="disabled"
          id="apelidoField"
          v-model.trim="model.content"
        />
      </label>
    </div>
  </div>
</template>

<script>
import { minLength } from "vuelidate/lib/validators";
import TooltipInformacaoAlterada from "@/components/forms/TooltipInformacaoAlterada.vue";
import FieldTemplateUpperCase from "@/components/forms/fields/empresa/FieldTemplateUpperCase.vue";
export default {
  extends: FieldTemplateUpperCase,
  props: {
    disabled: Boolean,
    modelProp: Object,
    recentUpdatedField: Boolean,
  },
  data() {
    return {
      model: {
        name: "prefixo",
        content: "",
      },
    };
  },
  methods: {
    isInvalid() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.mxToggleErrorMessageAlert("Campo Prefixo inválido");
        return true;
      }
      return false;
    },
  },
  validations: {
    model: {
      content: {
        minLength: minLength(1),
      },
    },
  },
  components: {
    TooltipInformacaoAlterada,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/style.scss";
label {
  width: 100% !important;
}
</style>
